import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpfile" id="xmpfile"></a>
    <h1 {...{
      "id": "requireuxpxmpxmpfile"
    }}>{`require('uxp').xmp.XMPFile`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0  `}</p>
    <a name="new-xmpfile-new" id="new-xmpfile-new"></a>
    <h2 {...{
      "id": "xmpfile"
    }}>{`XMPFile()`}</h2>
    <p>{`This class corresponds to the Adobe XMP Toolkit’s File Handler component, which provides convenient I/O access to the main,
or document level, XMP for a file. The File Handler supports those file formats in which you can embed XMP metadata,
as defined in the XMP Specification. It allows you to add XMP where none currently exists, expand existing XMP without
regard to existing padding, and reconcile XMP with other metadata formats. The XMP Toolkit also supplies the Packet
Scanner as a fallback solution for unsupported file formats. It provides more limited accesses to all file formats by
performing a dump file scan. It can update a file, but cannot extend the packet or reconcile other metadata formats.
The XMPScript API does not currently support retrieving thumbnails.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example of using the XMPFile class to get the XMPMeta object
// Import the XMPFile class
const { XMPFile } = require("uxp").xmp;

// Create a new XMPFile object
const xmpFile = new XMPFile("sample.psd", XMPConst.FILE_PHOTOSHOP, XMPConst.OPEN_FOR_UPDATE);

// Get the XMPMeta object
const xmpMeta = xmpFile.getXMP();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example of using the XMPFile class to get the XMPPacketInfo object
// Import the XMPFile class
const { XMPFile } = require("uxp").xmp;

// Create a new XMPFile object
const xmpFile = new XMPFile("sample.psd", XMPConst.FILE_PHOTOSHOP, XMPConst.OPEN_FOR_UPDATE);

Get XMPPacketInfo object
const xmpPacketInfo = xmpFile.getPacketInfo();
console.log(xmpPacketInfo.length);
console.log(xmpPacketInfo.offset);
console.log(xmpPacketInfo.padSize);
console.log(xmpPacketInfo.charForm);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Example of using the XMPFile class to get the XMPFileInfo object
// Import the XMPFile class
const { XMPFile } = require("uxp").xmp;

// Create a new XMPFile object
const xmpFile = new XMPFile("sample.psd", XMPConst.FILE_PHOTOSHOP, XMPConst.OPEN_FOR_UPDATE);

// Get XMPFileInfo object
const xmpFileInfo = xmpFile.getFileInfo();
console.log(xmpFileInfo.filePath);
console.log(xmpFileInfo.format);
`}</code></pre>
    <a name="new-xmpfile-new" id="new-xmpfile-new"></a>
    <h2 {...{
      "id": "xmpfilefilepath-format-openflags"
    }}>{`XMPFile(filePath, format, openFlags)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`filePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string containing the file path of a document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`format`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The file format constant. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#file-format-numeric-constants"
            }}>{`File format numeric constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`openFlags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The open options for the file. One of these constants:`}<br></br>{`                          - XMPConst.OPEN_FOR_READ - Open for read-only access.`}<br></br>{`                          - XMPConst.OPEN_FOR_UPDATE - Open for reading and writing.`}<br></br>{`                          - XMPConst.OPEN_ONLY_XMP - Only the XMP is wanted, allows space/time optimizations.`}<br></br>{`                          - XMPConst.OPEN_STRICTLY - Be strict about locating XMP and reconciling with other forms.`}<br></br>{`                          - XMPConst.OPEN_USE_SMART_HANDLER - Require the use of a smart handler. No packet scanning is performed.`}<br></br>{`                          - XMPConst.OPEN_USE_PACKET_SCANNING - Force packet scanning, do not use a smart handler.`}<br></br>{`                          - XMPConst.OPEN_LIMITED_SCANNING - Only packet-scan files known to need scanning.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <a name="xmpfile-canputxmp" id="xmpfile-canputxmp"></a>
    <h2 {...{
      "id": "canputxmpxmpdata"
    }}>{`canPutXMP(xmpData)`}</h2>
    <p>{`Reports whether XMP metadata of a given size can be updated for this file.
This is particularly important if the packet size is increased.`}</p>
    <p>{`Considers only the length of the serialized packet; does not keep the provided XMP.
Use putXMP() to actually update the XMP in the open file.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: boolean Returns true if the given XMP can be put into this file.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The XMP metadata as an XMPMeta object`}<br></br>{`                or The XMP metadata as a string containing an XMP packet`}<br></br>{`                or The XMP metadata as an Array of Number containing raw XMP packet data.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <a name="xmpfile-closefile" id="xmpfile-closefile"></a>
    <h2 {...{
      "id": "closefilecloseflags"
    }}>{`closeFile(closeFlags)`}</h2>
    <p>{`Closes this open file, after writing to it as necessary; that is, if the file was opened for update,
and if the XMP metadata was updated or injected. The options provided when the file was opened determine
whether this function reconciles the XMP with other forms of metadata; that is, whether any legacy metadata
is also updated to be consistent with the XMP metadata.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`closeFlags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A close-option constant, or 0. Close options are:                          XMPConst.`}<inlineCode parentName="td">{`CLOSE_UPDATE_SAFELY`}</inlineCode>{` - Write into a temporary file then swap for crash safety.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="xmpfile-getxmp" id="xmpfile-getxmp"></a>
    <h2 {...{
      "id": "getxmp"
    }}>{`getXMP()`}</h2>
    <p>{`Retrieves and parses the existing XMP metadata from this file. If the file format contains legacy metadata in a format
that is recognized by the File Handler, the function creates an XMP packet containing the metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPMeta`}</inlineCode>{` - Returns an XMPMeta object, or null if the files does not contain XMP or convertible legacy metadata.  `}</p>
    <a name="xmpfile-getpacketinfo" id="xmpfile-getpacketinfo"></a>
    <h2 {...{
      "id": "getpacketinfo"
    }}>{`getPacketInfo()`}</h2>
    <p>{`Retrieves the raw XMP packet from this file, along with information about the packet. The options with
which the file was opened determine whether this function reconciles other forms of metadata with the XMP.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPPacketInfo`}</inlineCode>{` - Returns an XMPPacketInfo object, or null if the files does not contain XMP metadata.  `}</p>
    <a name="xmpfile-getfileinfo" id="xmpfile-getfileinfo"></a>
    <h2 {...{
      "id": "getfileinfo"
    }}>{`getFileInfo()`}</h2>
    <p>{`Retrieves basic information about this file.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPFileInfo`}</inlineCode>{` - Returns an XMPFileInfo object.  `}</p>
    <a name="xmpfile-putxmp" id="xmpfile-putxmp"></a>
    <h2 {...{
      "id": "putxmpxmpdata"
    }}>{`putXMP(xmpData)`}</h2>
    <p>{`Supplies new XMP metadata for this file. The file is not actually written until closeFile() is called.
The options provided when the file was opened determine whether that function reconciles the XMP with other
forms of metadata; that is, whether any legacy metadata is also updated to be consistent with the XMP metadata.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The XMP metadata as an XMPMeta object`}<br></br>{`                or The XMP metadata as a String containing an XMP packet`}<br></br>{`                or The XMP metadata as an Array of Number containing raw XMP packet data.`}<br></br></td>
        </tr>
      </tbody>
    </table>
    <a name="xmpfile-getformatinfo" id="xmpfile-getformatinfo"></a>
    <h2 {...{
      "id": "getformatinfoformat"
    }}>{`getFormatInfo(format)`}</h2>
    <p>{`Reports the supported features for the given file format.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - Returns a logical OR of bit-flag constants, or 0 if the format is not handled  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`format`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The file format constant. See XMPConst for more details`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      